// extracted by mini-css-extract-plugin
module.exports = {"container":"BankVerifiedPayBillScreen_container__1TbhF","billAmount":"BankVerifiedPayBillScreen_billAmount__3iX8D"};